import React from "react";
import styled from "styled-components";

import Margin from "./Margin";
import Helmet from "../Helmet";
import Link from "../../util/link";
import Text from "../Text";
import Button from "../Button";

import SubmittableLogoWhite from "../../../images/logos/submittable-logo-w.png";
import SubmittableLogoBlack from "../../../images/logos/submittable-logo-b.png";
import theme from "../../../styles/theme";
import AnnouncementBar from "../AnnouncementBar";

const {
	colors,
	breakPoints: { screenQuery },
} = theme;

const Wrapper = styled.div`
	min-height: 100vh;
	position: relative;
	z-index: ${theme.navbarZIndex};
	padding-bottom: 85px;
	${(props) => (props.backgroundColor ? `background-color: ${props.backgroundColor};` : "")}
`;
const Header = styled.div`
	background-color: ${(props) =>
		props.lightHeader ? colors.grayscale.white : colors.grayscale.main};
	box-shadow: ${(props) => (props.headerShadow ? theme.boxShadow : `none`)};
	height: 85px;
	display: grid;
	align-items: center;
	${(props) => (props.centerLogo ? `text-align: center;` : ``)}
	${screenQuery.small} {
		> * {
			text-align: ${(props) => (props.menu || props.logoLeft ? `none` : `center`)};
		}
	}
	${screenQuery.mobile} {
		height: auto;
		min-height: 85px;
		> * {
			${(props) => (props.menu ? `padding-top: 30px;` : ``)}
			text-align:  ${(props) => (props.logoLeft ? `none` : `center`)};
		}
	}

	${(props) =>
		props.stickyHeader
			? `
        position: sticky;
        top: 0;
    `
			: null};

	position: relative;
	z-index: 100;
`;

const Logo = styled.img`
	width: ${(props) => props.logoWidth || 138}px;
`;
const Menu = styled.div`
	display: flex;
	float: right;
	justify-content: space-between;
	align-items: center;
	position: relative;
	top: 7px;
	> :first-child {
		margin-right: 20px;
	}
	${screenQuery.mobile} {
		float: none;
		flex-wrap: wrap;
		margin: 10px 0;
		> * {
			width: 100%;
			margin: 8px 0px !important;
		}
	}
`;
const SignInButton = styled(Button)``;
const ChildWrapper = styled.div`
	height: 100%;
`;

const Footer = styled.div`
	background-color: ${colors.grayscale.main};
	height: 85px;
	display: grid;
	align-items: center;
	position: absolute;
	bottom: 0;
	width: 100%;
	${(props) => (props.centerLogo ? `text-align: center;` : ``)}
`;
const Copyright = styled(Text)`
	display: inline;
	font-size: 1em;
	margin-left: 10px;
	color: ${colors.grayscale.white};
	position: relative;
	top: 6px;
`;

export default ({
	children,
	pageTitle,
	description,
	location,
	updatedAt,
	noIndex,
	backgroundColor,
	featuredImage,
	headerLogoLink,
	footerLogoLink,
	centerLogo,
	logoWidth,
	...props
}) => {
	return (
		<Wrapper backgroundColor={backgroundColor}>
			<Helmet
				pageTitle={pageTitle}
				description={description}
				location={location}
				updatedAt={updatedAt}
				noIndex={noIndex}
				featuredImage={featuredImage}
			/>
			<AnnouncementBar />
			<Header centerLogo={centerLogo} menu={props.helpMenu} {...props}>
				<Margin>
					<Link to={headerLogoLink || "/"}>
						<Logo
							logoWidth={logoWidth}
							src={props.lightHeader ? SubmittableLogoBlack : SubmittableLogoWhite}
							alt="Submittable Logo"
						/>
					</Link>
					{props.helpMenu ? (
						<Menu>
							<SignInButton pill={1} link="https://manager.submittable.com/login">
								Sign In / Sign Up
							</SignInButton>
							<Text component="b6" css={{ margin: 0 }}>
								<Link bold={1} to="http://help.submittable.com/" color="black">
									Help
								</Link>
							</Text>
						</Menu>
					) : null}
				</Margin>
			</Header>
			<ChildWrapper>{children}</ChildWrapper>
			<Footer centerLogo={centerLogo}>
				<Margin css={centerLogo ? null : { textAlign: "right" }}>
					<Link to={footerLogoLink || "/"}>
						<Logo
							src={props.lightFooter ? SubmittableLogoBlack : SubmittableLogoWhite}
							alt="Submittable Logo"
						/>
					</Link>
					<Copyright component="b5" color="white">
						© {new Date().getFullYear()}
					</Copyright>
				</Margin>
			</Footer>
		</Wrapper>
	);
};
